export default __webpack_public_path__ + "static/media/rain.8a3ce62a.svg";